import {
    ADD_DATA,
    DELETE_DATA,
    DELETE_FILES,
    GET_ALL_DATA,
    GET_ALL_IDEATION,
    UPDATE_DATA,
} from "@/api/ideation/file";
import querystring from "query-string";

const state = {
    list: [],
    ideation: [],
};

const mutations = {
    SET_LIST: (state, payload) => {
        state.list = payload;
    },
    SET_IDEATION: (state, payload) => {
        state.ideation = payload;
    },
    UPDATE_DATA(args) {
        state.list.forEach((data, i) => {
            if (data.id == args.id) {
                console.log("data", args);
                state.list[i] = JSON.stringify(JSON.parse(args));
            }
        });
    },
};

const actions = {
    GET_LIST: async ({
        commit
    }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_ALL_DATA(params);
        const data = resp.data.data;
        commit("SET_LIST", data);
    },
    GET_LIST_IDEATION: async ({
        commit
    }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_ALL_IDEATION(params);
        const data = resp.data.data;
        commit("SET_IDEATION", data);
    },

    CREATE_DATA: async ({ commit }, args) => {
        return await ADD_DATA(args);
    },
    UPDATE_FILE: async ({ }, args) => {
        return await UPDATE_DATA(args);
    },
    DELETE_DATA: async ({}, id) => {
        return await DELETE_DATA(id);
    },
    DELETE_FILES: async ({}, id) => {
        return await DELETE_FILES(id);
    },
};

const getters = {
    list: (state) => state.list,
    ideation: (state) => state.ideation,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};